import React from 'react';
import './RecommendedLabel.scss';

export default function (props) {
    let labelText;
    let iconClass;

    if(!props.type) {
        return null;
    }

    switch(props.type) {
        case 'dont-buy':
            labelText = 'Don\'t Buy';
            iconClass = 'crux-icons-dontbuy';
            break;
        case 'recommended':
            labelText = 'Recommended';
            iconClass = 'crux-icons-recommended';
            break;
        case 'best-buy':
            labelText = 'Best Buy';
            iconClass = 'crux-icons-best-buy';
            break;
        default:
            labelText = '';
            iconClass = '';
    }

    return (
        <div className='crux-label-style crux-label-style--small text-left'>
            <span className={`crux-icons ${iconClass}`} ></span>
            <span> {labelText}</span>
        </div>
    );
}



// WEBPACK FOOTER //
// ./resources/modules/products/v2_0/components/RecommendedLabel/index.jsx